import React from 'react';
import { FDIcon, FDLabelText, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const Benefit = ({
  text,
  icon,
}) => {
  return (
    <FDStack direction={'column'} alignItems={'center'}>
      <FDIcon icon={icon} size={'lg'} color="primary" />
      <FDLabelText value={text} size={'lg'} />
    </FDStack>
  );
};

Benefit.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};
